// Constants:
const $elements = document.querySelectorAll('.fade')
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('fade-in')
    }
  })
}, { threshold: 0.5 })

// Context:
$elements.forEach($element => observer.observe($element))